import { getApiBaseUrl } from "../constant";
import instance from "../utils/api_instance.util";


export const exportUserData = async (payload) => {
    try {
        const { data } = await instance.get(`/api/v1/user/user-list-download`, { params: { ...payload } });
        return data;
    } catch (error) {
        throw error;
    }
};

export const exportGameData = async (payload) => {
    try {
        const { data } = await instance.post(`/api/v1/game/download-game-list`, { ...payload });
        return data;
    } catch (error) {
        throw error;
    }
};

export const exportChallengeData = async (payload) => {
    try {
        const { data } = await instance.post(`/api/v1/game/downloadAllChallengeList`, { ...payload });
        return data;
    } catch (error) {
        throw error;
    }
};

export const downloadExportedFile = async (fileAddress, fallbackName = "export.xlsx") => {
    try {
        const filename = (fileAddress || "").split("/").pop() || fallbackName;
        const response = await instance.get(fileAddress, { responseType: "blob" });
        const blob = new Blob([response.data], {
            type: response.headers?.["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.href = blobUrl;
        anchor.download = filename;
        document.body.appendChild(anchor);
        anchor.click();
        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(anchor);
    } catch (error) {
        // Fallback: direct anchor navigation
        const filename = (fileAddress || "").split("/").pop() || fallbackName;
        const fallbackUrl = fileAddress?.startsWith("http")
          ? fileAddress
          : `${getApiBaseUrl()}${fileAddress}`;
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.href = fallbackUrl;
        anchor.download = filename;
        anchor.target = "_blank";
        anchor.rel = "noopener noreferrer";
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }
};